<template>
  <div>
    <div>
      <div class="">
        <h2
          class="heading-w3-agile"
          style="text-align:center; color:black; font-weight: 200; text-transform: uppercase;"
        >
          {{ $t("common.loginTitle") }}
        </h2>
        <form @submit.prevent="login">
          <div class="inputs-w3ls">
            <p style="color:black;">{{ $t("common.user") }}:</p>
            <i class="fa fa-envelope" aria-hidden="true"></i>
            <input
              type="text"
              class="email"
              name="Email"
              :placeholder="$t('common.user')"
              required=""
              v-model="credentials.username"
            />
          </div>
          <div class="inputs-w3ls">
            <p style="color:black;">{{ $t("common.password") }}:</p>
            <i class="fa fa-unlock-alt" aria-hidden="true"></i>
            <input
              type="password"
              class="password"
              name="Password"
              :placeholder="$t('common.password')"
              required=""
              v-model="credentials.password"
            />
          </div>
          <label class="anim" style="padding-bottom: 15px;">
            <a
              @click="onClickForgetPassword"
              style="color:black; cursor: pointer;"
              >{{ $t("registration.forgot_password") }}</a
            >
          </label>
          <input type="submit" :value="$t('common.sign_in')" />
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// import utils from '@/lib/utils'
// import config from "../../../build/config"
// import siteConfigEnum from "@/enum/siteConfigEnum";
//import LTECoreAlert from "@/components/LTESnackBar.vue"

export default {
  name: "Login",
  data() {
    return {
      credentials: {
        username: "",
        password: ""
      },
    };
  },
  computed: {
    ...mapGetters([])
  },
  methods: {
    login: function() {
      const credentials = {
        username: this.credentials.username.toLowerCase(),
        password: this.credentials.password
      };
      this.SET_TOKEN(credentials)
        .then(
          function() {
            this.CHECK_TOKEN().then(
              function() {
                let url = window.location.href.toString();
                this.GET_GENERAL_USER_SETTINGS().then(
                  function(res) {
                    let is_show_wellcome = res.data.is_show_wellcome
                    let num_projects = res.data.project_count
                    if (is_show_wellcome === false) {
                      this.$store.state.isShowWellcomeModal = !this.$store.state.isShowWellcomeModal
                    } else {
                      if (num_projects > 0) {
                        let targetUrl = url.replace(
                          "/account/login",
                          "/dashboard"
                        );
                        window.location.href = targetUrl;
                      } else {
                        let targetUrl = url.replace(
                          "/account/login",
                          "/no-project"
                        );
                        window.location.href = targetUrl;
                      }
                    }
                  }.bind(this)
                );
              }.bind(this)
            );
          }.bind(this)
        )
        .catch(
          function(error) {
            let error_code = error.response.status;
            let errors_key = error.response.data.errors_key
            let error_msg_view = this.$t(errors_key); //error.response.data.errors_key
            if (error_code === 429) {
              let error_msg = error.response.data.detail;
              let remaining_duration = error_msg.match(
                "Request was throttled. Expected available in ([0-9]+) seconds."
              )[1];
              error_msg_view = this.$t("login.wrongLoginTimes", {
                0: remaining_duration
              });
            }
            this.ON_SHOW_TOAST({
              message: this.$t(error_msg_view),
              styleType: "danger"
            });
          }.bind(this)
        );
    },
    setLang() {
      let data = this.$i18n.locale === "en" ? "vi" : "en";
      this.SET_LANG(data);
    },
    onClickForgetPassword: function() {
      this.$router.push({ name: "PasswordReset" });
    },
    ...mapActions([
      "SET_TOKEN",
      "CHECK_TOKEN",
      "ERROR_TOAST",
      "SET_LANG",
      "ON_SHOW_TOAST",
      "GET_GENERAL_USER_SETTINGS"
    ])
  },
  components: {
    //'lte-core-alert': LTECoreAlert
  },
  mounted() {
    let body = document.getElementsByTagName("BODY")[0];
    body.className = "login-page hold-transition";
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/login_style.css";
@import "font-awesome/css/font-awesome.min.css";
</style>



// WEBPACK FOOTER //
// src/views/Account/LoginV2.vue